<div class="footer d-flex">
  <div class="container">
    <div class="row">
      <div class="col-lg-6 col-md-6 flex-all-centered" >
        <span class="hidden-xs float-left ">{{ano | date:'yyyy'}} &copy; Todos os direitos reservados</span>
      </div>

      <div class="col-lg-6 col-md-6">
        <div class="logoRodape">
          <img [src]="'assets/img/logo/logo-sinqia.png'" class="imgLogo" alt="Logo Sinqia">
        </div>
      </div>
    </div>
  </div>
</div>
